export type Typography = {
  name: string;
  headlineFont: string;
  headlineWeight: number;
  bodyFont: string;
  googleFontsHref: string;
};

export const typography = {
  editorial: {
    name: "Editorial — Fraunces + Inter",
    headlineFont: "'Fraunces', serif",
    headlineWeight: 600,
    bodyFont: "'Inter', sans-serif",
    googleFontsHref:
      "https://fonts.googleapis.com/css2?family=Fraunces:ital,opsz,wght@0,9..144,500;0,9..144,600;0,9..144,700;1,9..144,500;1,9..144,600;1,9..144,700&family=Inter:wght@400;500;600;700&display=swap",
  },
  warmModern: {
    name: "Warm Modern — DM Serif Display + DM Sans",
    headlineFont: "'DM Serif Display', serif",
    headlineWeight: 400,
    bodyFont: "'DM Sans', sans-serif",
    googleFontsHref:
      "https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,400;0,9..40,500;0,9..40,600;0,9..40,700&family=DM+Serif+Display:ital@0;1&display=swap",
  },
  boldPunchy: {
    name: "Bold/Punchy — Playfair Display + Plus Jakarta Sans",
    headlineFont: "'Playfair Display', serif",
    headlineWeight: 900,
    bodyFont: "'Plus Jakarta Sans', sans-serif",
    googleFontsHref:
      "https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,700;0,900;1,700;1,900&family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap",
  },
} as const satisfies Record<string, Typography>;

export type TypographyName = keyof typeof typography;

export const defaultTypography = typography.editorial;
